import inRange from "lodash/inRange";
import reduce from "lodash/reduce";
import moment from "moment";
import { createSelector } from "reselect";
import { selectedPortfoliosSelector } from "selectors/portfolio";

const dealsSelector = (state) => state.deals;

const activityLevelFlex = (daysAgo) => {
  if (inRange(daysAgo, 0, 15)) return "highest";
  if (inRange(daysAgo, 15, 31)) return "high";
  if (inRange(daysAgo, 31, 46)) return "medium";
  if (inRange(daysAgo, 46, 61)) return "low";

  return "lowest";
};

const activityLevelLeasing = (daysAgo) => {
  if (inRange(daysAgo, 0, 4)) return "highest";
  if (inRange(daysAgo, 4, 8)) return "high";
  if (inRange(daysAgo, 8, 11)) return "medium";
  if (inRange(daysAgo, 11, 21)) return "low";

  return "lowest";
};

const dealsArraySelector = createSelector(dealsSelector, (deals) => deals);
export const dealSelector = createSelector(
  (state) => state.deal,
  (deal) => deal
);
export const dealStageAssetsSelector = createSelector(
  (state) => state.deal,
  (state) => state.dealStageAssets,
  (deal, dealStageAssets) => dealStageAssets.filter(({ dealId }) => dealId === deal.id)
);

export const dealPortfolioSelector = createSelector(
  (state) => state.deal,
  (deal) => (deal ? deal.portfolio : undefined)
);

export const getDeals = createSelector(dealsArraySelector, (deals) => deals);

export const activityLevel = (date, companyType) => {
  const daysAgo = moment().diff(moment(date), "days");

  return companyType === "flex" ? activityLevelFlex(daysAgo) : activityLevelLeasing(daysAgo);
};

export const totalDealsSelector = createSelector(selectedPortfoliosSelector, (selectedPortfolios) =>
  reduce(selectedPortfolios, (acc, p) => acc + p.totalDeals, 0)
);
